import React, { useState, useEffect } from 'react';
import { Container, Box, CircularProgress } from '@mui/material';
import CipherChallenge from '../components/CipherChallenge';
import { getRandomQuote, caesarEncode } from '../utils/cipherUtils';

const CaesarCipher = () => {
  const [challenge, setChallenge] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [userShift, setUserShift] = useState('');
  const [correctShift, setCorrectShift] = useState(null);

  const generateNewChallenge = async () => {
    setIsLoading(true);
    try {
      const quote = await getRandomQuote();
      if (quote) {
        // Generate a random shift between 1 and 25
        const shift = Math.floor(Math.random() * 25) + 1;
        setChallenge({
          encodedMessage: caesarEncode(quote.text, shift),
          correctAnswer: quote.text,
          originalText: quote.text,
          hint: `Each letter is shifted by ${shift} positions in the alphabet. For example, A becomes ${String.fromCharCode(65 + shift)}.`,
          difficulty: quote.difficulty
        });
        setCorrectShift(shift);
        setUserShift('');
      }
    } catch (error) {
      console.error('Error generating challenge:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    generateNewChallenge();
  }, []);

  const handleComplete = (result) => {
    if (result.success) {
      // If moveToNext is true, automatically generate a new challenge
      if (result.moveToNext) {
        generateNewChallenge();
      }
    }
  };

  if (isLoading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      {challenge && (
        <>
          <CipherChallenge
            title="Caesar Cipher Challenge"
            description="In a Caesar cipher, each letter in the alphabet is shifted by a fixed number of positions. This creates a simple but effective way to encode messages!"
            encodedMessage={challenge.encodedMessage}
            correctAnswer={challenge.correctAnswer}
            originalText={challenge.originalText}
            hint={challenge.hint}
            difficulty={challenge.difficulty}
            onComplete={handleComplete}
            userShift={userShift}
            setUserShift={setUserShift}
            correctShift={correctShift}
          />
        </>
      )}
    </Container>
  );
};

export default CaesarCipher; 